import React from 'react';
// import avitar from "../avitar.png"   you can import or use require
import "../links.css";




export default function Links() {



// const newplugin = defaultLayoutPlugin();

  return (
    <div className="links">
       
     
       <br></br>
       <div ><a
                    href="https://linkedin.com/in/jaytranberg"
                    target="blank"
                  ><img className="linkImg" src={require('../images/linkedin.jpeg')} alt="pic"/> 
       </a></div>
                  
       <div ><a
                    href="https://github.com/jtranberg"
                    target="blank"
                  >
       <img className="linkImg" src={require('../images/github.png')} alt="pic"/> 
       </a></div> <br></br>
       <div>
       <a href="mailto:jtranberg@hotmail.com" className="email">Contact Me</a>
      </div>

     
 </div>
  
  );
}
